export default "__VITE_ASSET__QS82p2R7__"